"use client";

import { c as _c } from "react/compiler-runtime";
import MediaTypeBadge from "@/components/drops/media/MediaTypeBadge";
interface Props {
  readonly tokenId: number | string;
  readonly mediaMimeType?: string | null | undefined;
  readonly mediaBadgeId?: string | undefined;
}
export default function CollectionCardMetadataBadge(t0) {
  const $ = _c(9);
  const {
    tokenId,
    mediaMimeType,
    mediaBadgeId
  } = t0;
  const t1 = `Token #${tokenId}`;
  let t2;
  if ($[0] !== tokenId) {
    t2 = <span className="tw-truncate">#{tokenId}</span>;
    $[0] = tokenId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== mediaBadgeId || $[3] !== mediaMimeType) {
    t3 = mediaMimeType && <MediaTypeBadge mimeType={mediaMimeType} {...mediaBadgeId ? {
      dropId: mediaBadgeId
    } : {}} size="sm" tone="muted" className="tw-shrink-0" iconClassName="tw-size-5" />;
    $[2] = mediaBadgeId;
    $[3] = mediaMimeType;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = <div aria-label={t1} className="tw-inline-flex tw-max-w-full tw-items-center tw-gap-1.5 tw-text-xs tw-font-medium tw-leading-5 tw-text-iron-500">{t2}{t3}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}